/* esm.sh - mainnet-js@4.0.0-next.4/dist/module/util/hd */
var t=(r,n)=>Array.from({length:n-r},(e,o)=>r+o),f=(r,n)=>(r===-1&&(r=n.findIndex(e=>e===null),r===-1&&(r=n.length)),r);export{t as arrayRange,f as getNextUnusedIndex};
//# sourceMappingURL=hd.mjs.map